import { useContext } from 'react';
import { ShoppingPlannerContext } from '../Context/ShoppingPlannerContext';

export const useProductsFromStates = () => {
    const {
        selectedDecor,
        floors,
        selectedInsulation,
        selectedSkirtingDecor,
        selectedInstallationAndCare,
        accessories,
        roomLength,
        roomWidth,
        roomSqm,
    } = useContext(ShoppingPlannerContext);

    const floor = floors.find((floor) => floor.decors.some((decor) => decor.articleNumber === selectedDecor));
    const decor = floor ? floor.decors.find((decor) => decor.articleNumber === selectedDecor) : undefined;
    const insulation = accessories.insulations.find((insulation) => insulation.articleNumber === selectedInsulation);
    const skirting = accessories.skirtings.find((skirting) =>
        skirting.decors.find((skirtingDecor) => skirtingDecor.articleNumber === selectedSkirtingDecor)
    );
    const skirtingDecor = skirting?.decors.find(
        (skirtingDecor) => skirtingDecor.articleNumber === selectedSkirtingDecor
    );
    const installationAndCare = accessories.installationAndCare.filter((installationAndCare) =>
        selectedInstallationAndCare.some((articleNumber) =>
            installationAndCare.variants.some((variant) => variant.articleNumber === articleNumber)
        )
    );

    const sqm =
        roomLength !== '' && roomWidth !== ''
            ? parseFloat(roomLength) * parseFloat(roomWidth)
            : roomSqm !== ''
            ? parseFloat(roomSqm)
            : 0;

    return {
        floor,
        decor,
        insulation,
        skirting,
        skirtingDecor,
        installationAndCare,
        sqm,
    };
};
